import { UserButton } from "../../../../molecules/buttons/UserButton";
import { UserControlReact } from "../UserControlReact";

export function UserButtonReact() {
  return (
    <UserButton>
      <UserControlReact />
    </UserButton>
  );
}
